module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_8011.788bfdc2.png";